const axios = require('axios');

import {
	serverUrl,
	presighnedUrl
} from '../properties'
const dataUrl = serverUrl;

export default {
	namespaced: true,
	state: {
		accountList: [],
		count: 0,
		advanceFilter: {},
		syncCount: 0,
		accountTab: 'detail'
	},
	mutations: {
		updateAccountList: (state, data) => {
			state.accountList = data
		},
		updateAccountCount: (state, data) => {
			state.count = data
		},
		setadvanceFilterAccount: (state, data) => {
			state.advanceFilter = data
		},
		updateSync: (state, data) => {
			state.syncCount = data
		}
	},
	getters: {
		getAccountList: (state, getters) => {
			return state.accountList
		},
		getAccountCount: (state, getters) => {
			return state.count
		},
		getSyncCount: (state, getters) => {
			return state.syncCount
		},
	},
	actions: {
		getAllTaggingStrategy({
			commit,
			state,
			getters,
			rootGetters,
			rootState
		}, payload) {
			return new Promise((resolve, reject) => {
				let url = dataUrl + "/account/getAllTaggingStrategy";
				let isPagination = "";
				if (payload && payload.hasOwnProperty('isPagination')) {
					isPagination = payload.isPagination
				} else {
					isPagination = true
				}

				let params = {
					sort: rootState.selectedSortOrder,
					q: rootState.searchFilterString.trim(),
					vendor_id: rootState.selectedVendorFilter,
					isPagination: isPagination,
					resultsPerPage: sessionStorage.getItem("accounts:showPerPage"),
					pageNumber: rootGetters.getCurrentPageNumber,
					active: (state.advanceFilter && state.advanceFilter.hasOwnProperty('active') ? state.advanceFilter.active : null),
					contactType: rootState.selectedAccountContactFilter,
					go_ops_str: (state.advanceFilter && state.advanceFilter.hasOwnProperty('go_ops') ? state.advanceFilter.go_ops : null),
					go_retail_str: (state.advanceFilter && state.advanceFilter.hasOwnProperty('go_retail') ? state.advanceFilter.go_retail : null),
					go_marketing_str: (state.advanceFilter && state.advanceFilter.hasOwnProperty('go_marketing') ? state.advanceFilter.go_marketing : null),
					go_dsp_str: (state.advanceFilter && state.advanceFilter.hasOwnProperty('go_dsp') ? state.advanceFilter.go_dsp : null),
					client_id: payload ? payload.client_id : undefined
				}
				axios({
					url: url,
					method: 'POST',
					data: params,
					headers: rootGetters.fetchHeader,
					responseType: 'json'
				}).then((response) => {
					if (response.data && response.data.data) {
						resolve(response.data.data);
						commit('updateAccountList', response.data.data)
						commit('updateAccountCount', response.data.count)
					}
				}).catch((error) => {
					console.log(error.response);
				})
			})

		},
		getAccountList({
			commit,
			state,
			getters,
			rootGetters,
			rootState
		}, payload) {
			return new Promise((resolve, reject) => {
				let url = dataUrl + "/account/list";
				let isPagination = "";
				if (payload && payload.hasOwnProperty('isPagination')) {
					isPagination = payload.isPagination
				} else {
					isPagination = true
				}

				let params = {
					sort: rootState.selectedSortOrder,
					q: rootState.searchFilterString.trim(),
					vendor_id: rootState.selectedVendorFilter,
					isPagination: isPagination,
					resultsPerPage: sessionStorage.getItem("accounts:showPerPage"),
					pageNumber: rootGetters.getCurrentPageNumber,
					active: (state.advanceFilter && state.advanceFilter.hasOwnProperty('active') ? state.advanceFilter.active : null),
					contactType: rootState.selectedAccountContactFilter,
					go_ops_str: (state.advanceFilter && state.advanceFilter.hasOwnProperty('go_ops') ? state.advanceFilter.go_ops : null),
					go_retail_str: (state.advanceFilter && state.advanceFilter.hasOwnProperty('go_retail') ? state.advanceFilter.go_retail : null),
					go_marketing_str: (state.advanceFilter && state.advanceFilter.hasOwnProperty('go_marketing') ? state.advanceFilter.go_marketing : null),
					go_dsp_str: (state.advanceFilter && state.advanceFilter.hasOwnProperty('go_dsp') ? state.advanceFilter.go_dsp : null)
				}
				axios({
					url: url,
					method: 'POST',
					data: params,
					headers: rootGetters.fetchHeader,
					responseType: 'json'
				}).then((response) => {
					if (response.data && response.data.data) {
						resolve(response.data.data);
						commit('updateAccountList', response.data.data)
						commit('updateAccountCount', response.data.count)
					}
				}).catch((error) => {
					console.log(error.response);
				})
			})

		},
		getClientListForExport({
			commit,
			state,
			getters,
			rootGetters,
			rootState
		}, payload) {
			return new Promise((resolve, reject) => {
				let url = dataUrl + "/account/exportAccountsList";
				let params = {
					sort: rootState.selectedSortOrder,
					q: rootState.searchFilterString.trim(),
					go_ops_str: (state.advanceFilter && state.advanceFilter.hasOwnProperty('go_ops') ? state.advanceFilter.go_ops : null),
					go_retail_str: (state.advanceFilter && state.advanceFilter.hasOwnProperty('go_retail') ? state.advanceFilter.go_retail : null),
					go_marketing_str: (state.advanceFilter && state.advanceFilter.hasOwnProperty('go_marketing') ? state.advanceFilter.go_marketing : null),
					go_dsp_str: (state.advanceFilter && state.advanceFilter.hasOwnProperty('go_dsp') ? state.advanceFilter.go_dsp : null),
				}
				axios({
					url: url,
					method: 'POST',
					data: params,
					headers: rootGetters.fetchHeader,
					responseType: 'json'
				}).then((response) => {
					if (response.data && response.data.data) {
						resolve(response.data.data);
					}
					else {
						resolve(response)
					}
				}).catch((error) => {
					console.log(error.response);
				})
			})

		},
		getAccountListForDownload({
			commit,
			state,
			getters,
			rootGetters,
			rootState
		}, payload) {
			return new Promise((resolve, reject) => {
				let url = dataUrl + "/account/list";
				let isPagination = "";
				if (payload && payload.hasOwnProperty('isPagination')) {
					isPagination = payload.isPagination
				} else {
					isPagination = true
				}

				let params = {
					sort: rootState.selectedSortOrder,
					q: rootState.searchFilterString.trim(),
					vendor_id: rootState.selectedVendorFilter,
					isPagination: isPagination,
					resultsPerPage: sessionStorage.getItem("accounts:showPerPage"),
					pageNumber: rootGetters.getCurrentPageNumber,
					active: (state.advanceFilter && state.advanceFilter.hasOwnProperty('active') ? state.advanceFilter.active : null),
					contactType: rootState.selectedAccountContactFilter,
					go_ops_str: (state.advanceFilter && state.advanceFilter.hasOwnProperty('go_ops') ? state.advanceFilter.go_ops : null),
					go_retail_str: (state.advanceFilter && state.advanceFilter.hasOwnProperty('go_retail') ? state.advanceFilter.go_retail : null),
					go_marketing_str: (state.advanceFilter && state.advanceFilter.hasOwnProperty('go_marketing') ? state.advanceFilter.go_marketing : null),
					client_id: rootState.selectedClientFilter

				}
				axios({
					url: url,
					method: 'POST',
					data: params,
					headers: rootGetters.fetchHeader,
					responseType: 'json'
				}).then((response) => {
					if (response.data && response.data.data) {
						resolve(response.data.data);
						commit('updateAccountCount', response.data.count)
					}
				}).catch((error) => {
					console.log(error.response);
				})
			})

		},
		getVendorByClient({
			commit,
			state,
			getters,
			rootGetters,
			rootState
		}, payload) {
			return new Promise((resolve, reject) => {
				let url = dataUrl + "/account/getVendorForClientCG"
				axios({
					url: url,
					method: 'POST',
					data: payload,
					headers: rootGetters.fetchHeader,
					responseType: 'json'
				}).then((response) => {
					resolve(response.data)
				}).catch((error) => {
					console.log(error)
				})
			})

		},
		saveAccProfileBudget({
			commit,
			state,
			getters,
			rootGetters,
			rootState
		}, payload) {
			return new Promise((resolve, reject) => {
				let url = dataUrl + "/budget/add"
				if (payload) {
					payload['userName'] = JSON.parse(window.localStorage.session).name;
				}
				axios({
					url: url,
					method: 'POST',
					data: payload,
					headers: rootGetters.fetchHeader,
					responseType: 'json'
				}).then((response) => {
					resolve(response.data)
				}).catch((error) => {
					console.log(error)
				})
			})

		},
		getListItems({
			commit,
			state,
			rootGetters
		}, payload) {
			return new Promise((resolve, reject) => {
				let id = {
					client_id: payload.client_id
				}
				axios({
					url: dataUrl + '/account/get' + payload.type + 'ForClient',
					method: 'POST',
					headers: rootGetters.fetchHeader,
					data: id,
					responseType: 'json'
				}).then(response => {
					resolve(response.data)
				}).catch(error => {
					console.log(error)
				})
			})
		},
		getSellerVendorDetailForProfile({
			commit,
			state,
			rootGetters
		}, payload) {
			return new Promise((resolve, reject) => {
				let id = {
					profile_id: payload.profileId
				}
				axios({
					url: dataUrl + '/account/' + payload.type + 'ForProfile',
					method: 'POST',
					headers: rootGetters.fetchHeader,
					data: id,
					responseType: 'json'
				}).then(response => {
					resolve(response.data)
				}).catch(error => {
					console.log(error)
				})
			})
		},
		deleteItemFromBudgetItem({
			commit,
			state,
			rootGetters
		}, payload) {
			return new Promise((resolve, reject) => {
				axios({
					url: dataUrl + '/budget/del',
					method: 'POST',
					headers: rootGetters.fetchHeader,
					data: payload,
					responseType: 'json'
				}).then((response) => {
					console.log(response.data);
					resolve(response.data)
				}).catch((error) => {
					console.log(error);
				})
			})
		},
		getAccBudgetsByProfileId({
			commit,
			state,
			getters,
			rootGetters,
			rootState
		}, payload) {
			return new Promise((resolve, reject) => {
				let url = dataUrl + "/budget/get"
				axios({
					url: url,
					data: payload,
					headers: rootGetters.fetchHeader,
					responseType: 'json',
					method: 'POST'
				}).then((response) => {
					resolve(response.data)
				}).catch((error) => {
					console.log(error)
				})
			})

		},
		getVendorDataById({
			commit,
			state,
			getters,
			rootGetters,
			rootState
		}, payload) {
			return new Promise((resolve, reject) => {

				let url = dataUrl + "/account/get"
				axios({
					url: url,
					method: 'POST',
					data: payload,
					headers: rootGetters.fetchHeader,
					responseType: 'json'
				}).then((response) => {
					resolve(response.data)
				}).catch((error) => {
					console.log(error.response);
				})
			})

		},
		getGoCallList({
			commit,
			state,
			getters,
			rootGetters,
			rootState
		}, payload) {
			return new Promise((resolve, reject) => {

				let url = dataUrl + "/account/getContact"
				axios({
					url: url,
					method: 'POST',
					data: payload,
					headers: rootGetters.fetchHeader,
					responseType: 'json'
				}).then((response) => {
					resolve(response.data)
				}).catch((error) => {
					console.log(error.response);
				})
			})

		},
		getContactsList({
			commit,
			state,
			getters,
			rootGetters,
			rootState
		}, payload) {
			return new Promise((resolve, reject) => {

				let url = dataUrl + "/account/getContact"
				axios({
					url: url,
					method: 'POST',
					data: payload,
					headers: rootGetters.fetchHeader,
					responseType: 'json'
				}).then((response) => {
					resolve(response.data)
				}).catch((error) => {
					console.log(error.response);
				})
			})

		},
		saveNewContact({
			commit,
			state,
			getters,
			rootGetters,
			rootState
		}, payload) {
			return new Promise((resolve, reject) => {
				payload.userName = JSON.parse(window.localStorage.session).name;

				let url = dataUrl + "/account/addContact"
				axios({
					url: url,
					method: 'POST',
					data: payload,
					headers: rootGetters.fetchHeader,
					responseType: 'json'
				}).then((response) => {
					resolve(response.data)
				}).catch((error) => {
					console.log(error.response);
				})
			})

		},
		getOtherBrands({
			commit,
			state,
			getters,
			rootGetters,
			rootState
		}, payload) {
			return new Promise((resolve, reject) => {
				let url = dataUrl + "/account/brandForVendorList";
				axios({
					url: url,
					method: 'POST',
					data: payload,
					headers: rootGetters.fetchHeader,
					responseType: 'json'
				}).then((response) => {
					resolve(response.data)
				}).catch((error) => {
					console.log(error.response);
				})
			})
		},
		getPresighnedURL({
			commit,
			state,
			getters,
			rootGetters,
			rootState
		}, payload) {
			return new Promise((resolve, reject) => {
				let url = presighnedUrl;
				let data = {
					"contentType": "text/csv",
					"ext": "csv"
				}
				axios({
					url: url,
					method: 'POST',
					headers: rootGetters.fetchHeader,
					data: data,
					responseType: 'json'
				}).then((response) => {
					console.log(response.data);
					resolve(response.data)
				}).catch((error) => {
					console.log(error);
				})
			})
		},
		uploadFile({
			commit,
			state,
			getters,
			rootGetters,
			rootState
		}, payload) {
			return new Promise((resolve, reject) => {

				let headers = { 'Content-Type': 'text/csv' };

				axios({
					url: payload.url,
					method: 'PUT',
					headers: rootGetters.fetchHeader,
					data: payload.data,
					headers: headers
				}).then((response) => {
					console.log(response.data);
					resolve(response.data)
				}).catch((error) => {
					console.log(error);
				})
			})
		},
		updateFileData({
			commit,
			state,
			getters,
			rootGetters,
			rootState
		}, payload) {
			return new Promise((resolve, reject) => {

				payload.userName = JSON.parse(window.localStorage.session).name;
				payload.userMail = JSON.parse(window.localStorage.session).username;

				//	let url = dataUrl + "/account/updateBulkData";
				let url = dataUrl + "/account/updateAccountsData";

				axios({
					url: url,
					method: 'POST',
					headers: rootGetters.fetchHeader,
					data: payload
				}).then((response) => {
					console.log(response.data);
					resolve(response.data)
				}).catch((error) => {
					console.log(error);
				})
			})
		},
		checkIfUpdating({
			commit,
			state,
			getters,
			rootGetters,
			rootState
		}, payload) {
			return new Promise((resolve, reject) => {
				//	let url = dataUrl + "/account/updateBulkData";
				let url = dataUrl + "/account/sync";

				axios({
					url: url,
					method: 'POST',
					headers: rootGetters.fetchHeader,
					data: payload
				}).then((response) => {

					resolve(response.data.count)
					commit('updateSync', response.data.count)

				}).catch((error) => {
					console.log(error);
				})
			})
		},
		saveNewVendor({
			commit,
			state,
			getters,
			rootGetters,
			rootState
		}, payload) {
			return new Promise((resolve, reject) => {
				payload.userName = JSON.parse(window.localStorage.session).name;
				let url = dataUrl + "/account/saveVendormaster";

				axios({
					url: url,
					method: 'POST',
					headers: rootGetters.fetchHeader,
					data: payload
				}).then((response) => {

					resolve(response.data)
				}).catch((error) => {
					console.log(error);
				})
			})
		},
		storeMerchantData({
			commit,
			state,
			getters,
			rootGetters,
			rootState
		}, payload) {
			return new Promise((resolve, reject) => {
				payload.userName = JSON.parse(window.localStorage.session).name;
				let url = dataUrl + "/account/saveclientMerchant";

				axios({
					url: url,
					method: 'POST',
					headers: rootGetters.fetchHeader,
					data: payload
				}).then((response) => {

					resolve(response.data)
				}).catch((error) => {
					console.log(error);
				})
			})
		},
		storeVendorData({
			commit,
			state,
			getters,
			rootGetters,
			rootState
		}, payload) {
			return new Promise((resolve, reject) => {
				payload.userName = JSON.parse(window.localStorage.session).name;
				let url = dataUrl + "/account/storeAllVendorData";
				axios({
					url: url,
					method: 'POST',
					headers: rootGetters.fetchHeader,
					data: payload
				}).then((response) => {
					rootState.selectedClientFilter = rootState.selectedClientFilter ? rootState.selectedClientFilter : (response.data && response.data.id ? response.data.id : '')
					//	commit('setSelectedClientFilter', response.data.id)
					resolve(response.data)
				}).catch((error) => {
					console.log(error);
				})
			})
		},
		getDetails({
			commit,
			state,
			getters,
			rootGetters,
			rootState
		}, payload) {
			return new Promise((resolve, reject) => {
				let url = dataUrl + "/account/getDetails";
				axios({
					url: url,
					method: 'POST',
					headers: rootGetters.fetchHeader,
					data: payload
				}).then((response) => {

					resolve(response.data)
				}).catch((error) => {
					console.log(error);
				})
			})
		},
		getAllMerchant({
			commit,
			state,
			getters,
			rootGetters,
			rootState
		}, payload) {
			return new Promise((resolve, reject) => {
				let url = dataUrl + "/account/getAllMerchant";
				axios({
					url: url,
					method: 'POST',
					headers: rootGetters.fetchHeader,
				}).then((response) => {

					resolve(response.data)
				}).catch((error) => {
					console.log(error);
				})
			})
		},
		getCountryList({
			commit,
			state,
			getters,
			rootGetters,
			rootState
		}, payload) {
			return new Promise((resolve, reject) => {
				let url = dataUrl + "/account/country";

				axios({
					url: url,
					method: 'POST',
					headers: rootGetters.fetchHeader,
				}).then((response) => {
					console.log(response.data);
					resolve(response.data)
				}).catch((error) => {
					console.log(error);
				})
			})
		},
		getMerchantNameList({
			commit,
			state,
			getters,
			rootGetters,
			rootState
		}, payload) {
			return new Promise((resolve, reject) => {
				let url = dataUrl + "/account/merchants";

				axios({
					url: url,
					method: 'POST',
					headers: rootGetters.fetchHeader,
				}).then((response) => {
					console.log(response.data);
					resolve(response.data)
				}).catch((error) => {
					console.log(error);
				})
			})
		},
		getCurrencyCountryList({
			commit,
			state,
			getters,
			rootGetters,
			rootState
		}, payload) {
			return new Promise((resolve, reject) => {
				let url = dataUrl + "/account/currencyCountryList";
				axios({
					url: url,
					method: 'POST',
					headers: rootGetters.fetchHeader,
				}).then((response) => {
					console.log(response.data);
					resolve(response.data)
				}).catch((error) => {
					console.log(error);
				})
			})
		},

		saveVendorInVendorMaster({
			commit,
			state,
			getters,
			rootGetters,
			rootState
		}, payload) {
			return new Promise((resolve, reject) => {
				let url = dataUrl + "/account/saveNewVendorMaster";
				payload.userName = JSON.parse(window.localStorage.session).name;

				axios({
					url: url,
					method: 'POST',
					headers: rootGetters.fetchHeader,
					data: payload
				}).then((response) => {
					console.log(response.data);
					resolve(response.data)
				}).catch((error) => {
					console.log(error);
				})
			})
		},
		saveNewClientData({
			commit,
			state,
			getters,
			rootGetters,
			rootState
		}, payload) {
			return new Promise((resolve, reject) => {
				let url = dataUrl + "/account/createClient";
				payload.userName = JSON.parse(window.localStorage.session).name;

				axios({
					url: url,
					method: 'POST',
					headers: rootGetters.fetchHeader,
					data: payload
				}).then((response) => {
					console.log(response.data);
					resolve(response.data)
				}).catch((error) => {
					console.log(error);
				})
			})
		},
		saveEditSeller({
			commit,
			state,
			getters,
			rootGetters,
			rootState
		}, payload) {
			return new Promise((resolve, reject) => {
				let url = dataUrl + "/account/editSaveSeller";
				payload.userName = JSON.parse(window.localStorage.session).name;

				axios({
					url: url,
					method: 'POST',
					headers: rootGetters.fetchHeader,
					data: payload
				}).then((response) => {
					console.log(response.data);
					resolve(response.data)
				}).catch((error) => {
					console.log(error);
				})
			})
		},
		saveInstacart({
			commit,
			state,
			getters,
			rootGetters,
			rootState
		}, payload) {
			return new Promise((resolve, reject) => {
				let url = dataUrl + "/account/saveInstacart";
				payload.userName = JSON.parse(window.localStorage.session).name
				axios({
					url: url,
					method: 'POST',
					headers: rootGetters.fetchHeader,
					data: payload
				}).then((response) => {
					console.log(response.data)
					resolve(response.data)
				}).catch((error) => {
					console.log(error)
				})
			})
		},
		saveDSP({
			commit,
			state,
			getters,
			rootGetters,
			rootState
		}, payload) {
			return new Promise((resolve, reject) => {
				let url = dataUrl + "/account/saveDSP";
				payload.userName = JSON.parse(window.localStorage.session).name
				axios({
					url: url,
					method: 'POST',
					headers: rootGetters.fetchHeader,
					data: payload
				}).then((response) => {
					console.log(response.data)
					resolve(response.data)
				}).catch((error) => {
					console.log(error)
				})
			})
		},
		saveAccountData({
			commit,
			state,
			getters,
			rootGetters,
			rootState
		}, payload) {
			return new Promise((resolve, reject) => {
				let url = dataUrl + "/account/saveAccountData";
				payload.userName = JSON.parse(window.localStorage.session).name;

				axios({
					url: url,
					method: 'POST',
					headers: rootGetters.fetchHeader,
					data: payload
				}).then((response) => {
					console.log(response)
					resolve(response.data)
				}).catch((error) => {
					console.log(error);
				})
			})
		},
		delClient({
			commit,
			state,
			getters,
			rootGetters,
			rootState
		}, payload) {
			return new Promise((resolve, reject) => {
				let url = dataUrl + "/account/delClient";
				payload.userName = JSON.parse(window.localStorage.session).name;

				axios({
					url: url,
					method: 'POST',
					headers: rootGetters.fetchHeader,
					data: payload
				}).then((response) => {
					console.log(response.data);
					resolve(response.data)
				}).catch((error) => {
					console.log(error);
				})
			})
		},
		getAllInstacart: ({ commit, state, getters }) => {
			return new Promise((resolve, reject) => {
				axios({
					url: dataUrl + '/account/instacartProfile',
					method: 'POST',
					headers: getters.fetchHeader,
					responseType: 'json'
				}).then((response) => {
					resolve(response.data)
				}).catch((error) => {
					console.log(error)
				})
			})

		},
		getAllDSP: ({ commit, state, getters }) => {
			return new Promise((resolve, reject) => {
				axios({
					url: dataUrl + '/account/getDSP',
					method: 'POST',
					headers: getters.fetchHeader,
					responseType: 'json'
				}).then((response) => {
					resolve(response.data)
				}).catch((error) => {
					console.log(error)
				})
			})

		},
		getAgencyDSP: ({ commit, state, getters }) => {
			return new Promise((resolve, reject) => {
				axios({
					url: dataUrl + '/account/getAgencyDSP',
					method: 'POST',
					headers: getters.fetchHeader,
					responseType: 'json'
				}).then((response) => {
					resolve(response.data)
				}).catch((error) => {
					console.log(error)
				})
			})

		},
		getAccountSections: ({ commit, state, getters }, payload) => {
			return new Promise((resolve, reject) => {
				axios({
					url: dataUrl + '/account/getAccountData',
					method: 'POST',
					headers: getters.fetchHeader,
					data: payload,
					responseType: 'json'
				}).then(response => {
					resolve(response.data)
				}).catch(err => {
					console.log(err)
				})
			})
		},
		getAllAMC: ({ commit, state, getters }) => {
			return new Promise((resolve, reject) => {
				axios({
					url: dataUrl + '/account/getAMC',
					method: 'POST',
					headers: getters.fetchHeader,
					responseType: 'json'
				}).then(response => {
					console.log(response)
					resolve(response.data)
				}).catch(err => {
					console.log(err)
				})
			})
		},

		getTaggingStrategy({
			commit,
			state,
			getters,
			rootGetters,
			rootState
		}, payload) {
			return new Promise((resolve, reject) => {
				let url = dataUrl + "/account/getTaggingStrategy";
				payload.userName = JSON.parse(window.localStorage.session).name;

				axios({
					url: url,
					method: 'POST',
					headers: rootGetters.fetchHeader,
					data: payload
				}).then((response) => {
					console.log(response)
					resolve(response.data)
				}).catch((error) => {
					console.log(error);
				})
			})
		},

		setTaggingStrategy({
			commit,
			state,
			getters,
			rootGetters,
			rootState
		}, payload) {
			return new Promise((resolve, reject) => {
				let url = dataUrl + "/account/setTaggingStrategy";
				payload.userName = JSON.parse(window.localStorage.session).name;

				axios({
					url: url,
					method: 'POST',
					headers: rootGetters.fetchHeader,
					data: payload
				}).then((response) => {
					console.log(response)
					resolve(response.data)
				}).catch((error) => {
					console.log(error);
				})
			})
		},

		deleteTaggingStrategy({
			commit,
			state,
			getters,
			rootGetters,
			rootState
		}, payload) {
			return new Promise((resolve, reject) => {
				let url = dataUrl + "/account/deleteTaggingStrategy";
				payload.userName = JSON.parse(window.localStorage.session).name;

				axios({
					url: url,
					method: 'POST',
					headers: rootGetters.fetchHeader,
					data: payload
				}).then((response) => {
					console.log(response)
					resolve(response.data)
				}).catch((error) => {
					console.log(error);
				})
			})
		},

		getAccountTagCoverage({
			commit,
			state,
			getters,
			rootGetters,
			rootState
		}, payload) {
			return new Promise((resolve, reject) => {
				let url = dataUrl + "/account/getAccountTagCoverage";
				let isPagination = "";
				if (payload && payload.hasOwnProperty('isPagination')) {
					isPagination = payload.isPagination
				} else {
					isPagination = true
				}

				let params = {
					sort: rootState.selectedSortOrder,
					q: rootState.searchFilterString.trim(),
					vendor_id: rootState.selectedVendorFilter,
					isPagination: isPagination,
					resultsPerPage: sessionStorage.getItem("accounts:showPerPage"),
					pageNumber: rootGetters.getCurrentPageNumber,
					active: (state.advanceFilter && state.advanceFilter.hasOwnProperty('active') ? state.advanceFilter.active : null),
					contactType: rootState.selectedAccountContactFilter,
					go_ops_str: (state.advanceFilter && state.advanceFilter.hasOwnProperty('go_ops') ? state.advanceFilter.go_ops : null),
					go_retail_str: (state.advanceFilter && state.advanceFilter.hasOwnProperty('go_retail') ? state.advanceFilter.go_retail : null),
					go_marketing_str: (state.advanceFilter && state.advanceFilter.hasOwnProperty('go_marketing') ? state.advanceFilter.go_marketing : null),
					go_dsp_str: (state.advanceFilter && state.advanceFilter.hasOwnProperty('go_dsp') ? state.advanceFilter.go_dsp : null),
					client_ids: payload ? payload.client_ids : undefined
				}
				axios({
					url: url,
					method: 'POST',
					data: params,
					headers: rootGetters.fetchHeader,
					responseType: 'json'
				}).then((response) => {
					if (response && response.data) {
						resolve(response.data);
						// commit('updateAccountList', response.data.data)
						// commit('updateAccountCount', response.data.count)
					}
				}).catch((error) => {
					console.log(error.response);
				})
			})

		},
	}
}
